export interface ILang {
	[key: string]: {
		text: string;
		lng: 'en' | 'de' | 'ar' | 'gr' | 'tr';
		/** Short code shown in the selector pill (no flags — languages aren't countries). */
		code: string;
		/** English name, shown as a secondary label in the selector menu. */
		englishName: string;
		/**
		 * Whether this language appears in the language-selector dropdown.
		 * Defaults to true. Translation resources and routing (getLangWithKey,
		 * i18next) stay fully supported regardless — this only controls
		 * selector visibility, e.g. for a market we haven't launched yet.
		 */
		selectable?: boolean;
	};
}

const LANG: ILang = {
	EN: {
		text: 'English',
		lng: 'en',
		code: 'EN',
		englishName: 'English',
	},
	DE: {
		text: 'Deutsch',
		lng: 'de',
		code: 'DE',
		englishName: 'German',
		selectable: false, // Germany market not launched yet
	},
	AR: {
		text: 'العربية',
		lng: 'ar',
		code: 'AR',
		englishName: 'Arabic',
		selectable: false, // Arabic MENA market not launched yet
	},
	GR: {
		text: 'Ελληνικά',
		lng: 'gr',
		code: 'EL',
		englishName: 'Greek',
	},
	TR: {
		text: 'Türkçe',
		lng: 'tr',
		code: 'TR',
		englishName: 'Turkish',
		selectable: false, // Turkey market not launched yet
	},
};

/** Keys of the languages that should show up in the language-selector dropdown. */
export const SELECTABLE_LANG_KEYS = Object.keys(LANG).filter((k) => LANG[k].selectable !== false);

export const getLangWithKey = (key: ILang['key']['lng']): ILang['key'] => {
	// @ts-ignore
	return LANG[Object.keys(LANG).filter((f) => key.includes(LANG[f].lng))];
};

export default LANG;
